import { useMemo } from "react";

import { useGetThreads } from "app/pages/sales-intelligence/modules/ai-agent/queries/useGetThreads";

export const useThreadCreatedDate = (threadId: string | undefined): string | undefined => {
    const { data } = useGetThreads();
    const thread = useMemo(() => data?.find((t) => t.threadId === threadId), [data, threadId]);

    return thread?.createdDate;
};
